module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simulate"
  }, [_c('div', {
    staticClass: "recommend-account-opening-box"
  }, [_c('div', {
    staticClass: "compnay-text-icon-box"
  }, [_c('img', {
    staticClass: "compnay-text-icon",
    attrs: {
      "alt": "",
      "src": require("./images/bg.png")
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountApply == 0 || _vm.accountApply == 3),
      expression: "accountApply == 0 || accountApply == 3"
    }],
    attrs: {
      "id": "accountApply"
    }
  }, [_c('div', {
    staticClass: "input-name"
  }, [_c('img', {
    staticClass: "input-img",
    attrs: {
      "src": require("./images/user.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientName),
      expression: "clientName"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "id": "clientName",
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.clientName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.clientName = $event.target.value
      }, _vm.checkInput]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-name"
  }, [_c('img', {
    staticClass: "input-img",
    attrs: {
      "src": require("./images/phone.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel),
      expression: "tel"
    }],
    attrs: {
      "type": "tel",
      "id": "mobile",
      "maxlength": "11",
      "name": "phone",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-name"
  }, [_c('img', {
    staticClass: "input-img",
    attrs: {
      "src": require("./images/message.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    attrs: {
      "type": "tel",
      "name": "",
      "id": "verifyCode"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getYZM),
      expression: "getYZM"
    }],
    staticClass: "code-button",
    attrs: {
      "type": "button",
      "id": "getyzm"
    },
    on: {
      "click": _vm.getyzm
    }
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getYZM),
      expression: "!getYZM"
    }],
    staticClass: "yzmbutton code-button",
    attrs: {
      "id": "cxhq"
    }
  }, [_vm._v("重新获取" + _vm._s(_vm.timeText) + "s")])]), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('button', {
    staticClass: "submit-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("立即申请")])]), _vm._v(" "), _c('div', {
    staticClass: "submit-text mtb-10"
  }, [_vm._v("申请成功后请安装东航期货App进行模拟交易")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountApply == 1 || _vm.accountApply == 2),
      expression: "accountApply == 1 || accountApply == 2"
    }],
    attrs: {
      "id": "accountApplyShow"
    }
  }, [_c('div', {
    staticClass: "success-icon-box"
  }, [(_vm.accountApply == 1) ? _c('img', {
    staticClass: "success-icon",
    attrs: {
      "src": require("./images/success.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.accountApply == 2) ? _c('img', {
    staticClass: "success-icon",
    attrs: {
      "src": require("./images/fail.png"),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "apply-text"
  }, [_vm._v(_vm._s(_vm.applyText))])])]), _vm._v(" "), _c('div', {
    staticClass: "dowload-phone-icon"
  }, [_c('a', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.Download
    }
  }, [_c('img', {
    staticClass: "phone-icon-img phone-icon-img-ios",
    attrs: {
      "src": require("./images/ios.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.Download
    }
  }, [_c('img', {
    staticClass: "phone-icon-img phone-icon-img-android",
    attrs: {
      "src": require("./images/android.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toastShow),
      expression: "toastShow"
    }],
    attrs: {
      "id": "toast"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.toastText) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-361799b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/simulate/NewSimulate.vue
// module id = 878
// module chunks = 2